var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3289 17.4942V15.8281C13.3289 14.9443 12.9778 14.0968 12.3529 13.4718C11.728 12.8469 10.8804 12.4958 9.99666 12.4958H4.99827C4.1145 12.4958 3.26693 12.8469 2.64201 13.4718C2.01709 14.0968 1.66602 14.9443 1.66602 15.8281V17.4942",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49779 9.16379C9.33814 9.16379 10.83 7.67188 10.83 5.83153C10.83 3.99117 9.33814 2.49927 7.49779 2.49927C5.65743 2.49927 4.16553 3.99117 4.16553 5.83153C4.16553 7.67188 5.65743 9.16379 7.49779 9.16379Z",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3273 17.4943V15.8282C18.3268 15.0899 18.081 14.3727 17.6287 13.7891C17.1763 13.2056 16.543 12.7888 15.8281 12.6042",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3291 2.60742C14.0459 2.79095 14.6812 3.20781 15.1349 3.7923C15.5886 4.37678 15.8348 5.09564 15.8348 5.83555C15.8348 6.57545 15.5886 7.29431 15.1349 7.8788C14.6812 8.46328 14.0459 8.88015 13.3291 9.06367",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon05);
export default __webpack_public_path__ + "static/media/icon05.ccd1e8c27a956dd7b8a74e137143af61.svg";
export { ForwardRef as ReactComponent };